import { fbcFromFbclidQueryParam, gclidFromQueryParam } from "@capi/types";
import { IActionRequestTrackingInfo } from "@forms/schema";

const ACTION_TRACKING_COOKIE_NAMES_CONST = [
  "_fbp",
  "_fbc",
  "gclid",
  "test_event_code",
  "ttclid",
  "_ttp",
] as const;

export type ActionTrackingCookieName = typeof ACTION_TRACKING_COOKIE_NAMES_CONST[number];

export const ACTION_TRACKING_COOKIE_NAMES = ACTION_TRACKING_COOKIE_NAMES_CONST as unknown as ActionTrackingCookieName[];

export function getActionTrackingInfo(
  cookies: Partial<Record<ActionTrackingCookieName, unknown>>,
): IActionRequestTrackingInfo {
  return {
    fbp: cookies._fbp?.toString(),
    fbc: fbcFromFbclidQueryParam(window.location.href, console.error)?.fbc || cookies._fbc?.toString(),
    gclid: gclidFromQueryParam(globalThis.window.location.href, console.error)?.gclid || cookies.gclid?.toString(),
    test_event_code: cookies.test_event_code?.toString(),
    ttclid: cookies.ttclid?.toString(),
    _ttp: cookies._ttp?.toString(),
    pageUrl: window.location.href,
  };
}
